<template lang="pug">
div.animated.fadeIn
  b-card
    div.row
      div.col-sm-5
        h4.card-title.mb-0
          | Task Reporting
        div.small.text-muted
          | Displaying tasks reported
      div.col-sm-7.hidden-sm-down
        b-dropdown.float-right(type='button', variant='primary', v-if='userAccessLevel != "agent"')
          template(slot='button-content')
            i.icon-cloud-download
            | &nbsp;&nbsp;Export
          b-dropdown-item(@click='xlsx', type='button', variant='info')
            | Download as xlsx
          b-dropdown-item(@click='pdf', type='button', variant='info')
            | Download as pdf
        b-button.float-right(type='button', variant='primary', @click='pdf', v-else)
          i.icon-cloud-download
          | &nbsp;Export as pdf
    br
    crm-table-tm
</template>

<script>
import { ecrm, ecrmp } from '@/jsonToXlsx'
export default {
  name: 'dashboard',
  data() {
    return {
      userAccessLevel: this.$store.state.profile.accessLevel,
    }
  },
  mounted: function() {
  },
  methods: {
    xlsx: function() {
      ecrm()
    },
    pdf: function() {
      ecrmp()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/CRM/tm.vue?c86db59c